'use client';

import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import theme from '@/theme';
import { colorVariables } from '@/constants';

type Props = {
  showBottomBorder: boolean;
  item: any;
  isLastItem?: boolean;
};

const QAItem = ({ showBottomBorder, item, isLastItem }: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const [title, ...description] = item.title.split('-');

  return (
    <Box
      sx={{
        paddingBottom: 1.5,
        borderBottom: !showBottomBorder
          ? 'none'
          : `1px solid ${colorVariables.separatorColor}`,
        [theme.breakpoints.down('md')]: {
          borderBottom: isLastItem
            ? 'none'
            : `1px solid ${colorVariables.separatorColor}`,
          paddingBottom: isLastItem ? '0' : 1.5,
        },
      }}
    >
      <Typography
        fontWeight={500}
        variant='h4'
        lineHeight='22px'
        fontSize={13}
        letterSpacing={0.46}
        color={colorVariables.textDescription}
        textTransform='uppercase'
      >
        {title || ''}
      </Typography>

      <Typography
        mt={0.5}
        fontWeight={600}
        variant='h3'
        lineHeight='160%'
        fontSize={20}
        letterSpacing={0.15}
        color={colorVariables.blackColor}
      >
        {description?.join('-') || ''}
      </Typography>

      <Box
        sx={{
          position: expanded ? 'static' : 'absolute',
          left: expanded ? 'auto' : '-9999px',
          clipPath: expanded ? 'none' : 'inset(100%)',
          overflow: 'hidden',
          height: 'auto',
        }}
      >
        <Typography
          mt={1}
          fontWeight={400}
          lineHeight='143%'
          fontSize={14}
          letterSpacing={0.17}
          whiteSpace='pre-wrap'
          color={colorVariables.textDescription}
        >
          {item.content}
        </Typography>
      </Box>

      <Typography
        variant='body1'
        paddingY={0.5}
        tabIndex={0}
        component='button'
        color={theme.palette.success.main}
        fontSize={13}
        fontWeight={500}
        lineHeight='22px'
        letterSpacing={0.46}
        textTransform='uppercase'
        sx={{
          marginTop: 1,
          display: 'flex',
          gap: 0.5,
          alignItems: 'center',
          cursor: 'pointer',
          [theme.breakpoints.down('lg')]: {
            paddingY: 0,
          },
        }}
        onClick={handleToggle}
      >
        {!expanded ? 'Read more' : 'Read less'}
        {!expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </Typography>
    </Box>
  );
};

export default QAItem;
